export const visit = (vm, at) => {
at({ "zh-cn": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}}/{{totalBytes}}" }, "fileSizeLimit": "\u6587\u4EF6\u4E0D\u80FD\u5927\u4E8E {{size}}", "screenCapture": "\u5C4F\u5E55\u622A\u56FE" } } });
};